// extracted by mini-css-extract-plugin
export var arrowIcon = "navbtn-module--arrowIcon--71cyl";
export var btn = "navbtn-module--btn--T10dj";